/**
 * @file: 层板商品排列算法
 * @author: xiaolong.huang@dmall.com
 */
import * as UIToolkit from '../../../UIToolkit/index';
import SpaceAround from './spaceAround';
import SpaceBetween from './spaceBetween';
import LeftToRight from './leftToRight';
import RightToLeft from './rightToLeft';

export function layout(layer: CubeId): void {
    let type: LayoutType = UIToolkit.layoutType(layer);

    switch(type) {
        // 从左到右追加
        case '|||---':
            LeftToRight(layer);
            break;

        // // 从右到左追加
        case '---|||':
            RightToLeft(layer);
            break;

        // 均匀分布
        case '-|-|-':
            SpaceAround(layer);
            break;

        // 贴边均匀
        case '|-|-|':
            SpaceBetween(layer);
            break;

        default:
            break;
    }
}
